// Lightweight localStorage-backed activity log.
//
// Used by the Clock/History buttons on the Translate and Currency screens.
// Each entry is { id, kind, at, ...payload } where `kind` is "translate" or
// "currency". List is capped at 50 entries per kind so localStorage stays
// small.

const LS_KEY = "tiplingo_history_v1";
const MAX_PER_KIND = 50;

function read() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return { translate: [], currency: [] };
    const obj = JSON.parse(raw);
    return {
      translate: Array.isArray(obj?.translate) ? obj.translate : [],
      currency: Array.isArray(obj?.currency) ? obj.currency : [],
    };
  } catch {
    return { translate: [], currency: [] };
  }
}

function write(data) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(data));
  } catch {
    /* non-fatal */
  }
}

export function listHistory(kind) {
  const data = read();
  return data[kind] || [];
}

export function addHistory(kind, payload) {
  const data = read();
  const entry = {
    id: `h_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    kind,
    at: Date.now(),
    ...payload,
  };
  const list = [entry, ...(data[kind] || [])].slice(0, MAX_PER_KIND);
  data[kind] = list;
  write(data);
  return entry;
}

export function removeHistory(kind, id) {
  const data = read();
  data[kind] = (data[kind] || []).filter((e) => e.id !== id);
  write(data);
}

export function clearHistory(kind) {
  const data = read();
  data[kind] = [];
  write(data);
}

export function formatRelative(ts) {
  const diff = Date.now() - ts;
  const s = Math.floor(diff / 1000);
  if (s < 60) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d ago`;
  try {
    return new Date(ts).toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
    });
  } catch {
    return "";
  }
}
